import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';
import { TextBlurb } from '@components/modals/shared/styles';

export const containerStyles: CSS = {
  width: 'calc(100% - 32px)',
  padding: 0,

  '@tablet': {
    width: 625,
  },
};

export const headerStyles: CSS = {
  paddingTop: 16,
  paddingX: 16,

  '@tablet': {
    paddingTop: 24,
    paddingX: 24,
  },
};

export const ModalWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  paddingTop: 16,
  gap: 16,

  '@tablet': {
    paddingBottom: 0,
    gap: 24,
    paddingTop: 24,
  },
});

export const Content = styled('div', {
  paddingX: 16,
  width: '100%',

  '@tablet': {
    paddingX: 24,
  },
});

export const ButtonWrapper = styled('div', {
  padding: 16,
  marginTop: 8,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  boxShadow: '0px 0px 0px rgba(0, 0, 0, 0.04), 0px 8px 28px rgba(0, 0, 0, 0.28)',

  '@tablet': {
    boxShadow: 'unset',
    padding: 24,
    paddingTop: 0,
    marginTop: 0,
  },
});

export const HelperText = styled(TextBlurb, {
  base: 'M',
  fontStyle: 'medium',
  color: '$neutral400',
  marginTop: 16,
  '@tablet': {
    base: 'L',
    color: '$neutral400',
    lineHeight: 1.5,
    marginTop: 0,
  },
});

export const InstructionHeader = styled('h2', {
  base: 'M',
  fontStyle: 'semibold',
  marginBottom: 4,
  width: '100%',

  '@tablet': {
    base: 'L',
    marginBottom: 8,
  },
});

export const InstructionHelper = styled('p', {
  width: '100%',
  marginBottom: 16,
  base: 'M',
  color: '$neutral400',
  fontWeight: 500,
});
